import { createSelector } from "@reduxjs/toolkit";

import { UserRoles } from "../../model/user/types/UserRoles";
import { RootState } from "../store";

const userState = (state: RootState) => state.user;

const selectLoggedInUserId = createSelector(
  userState,
  (state) => state.loggedInUserId,
);

const selectLoggedInUser = createSelector(
  userState,
  (state) => state.loggedInUser,
);

const selectIsUserOrgMember = createSelector(
  userState,
  (state) =>
    state.loggedInUser?.organizationId?.length &&
    state.loggedInUser?.roles.includes(UserRoles.MEMBER),
);

const selectLastUnreadPSAs = createSelector(
  userState,
  (state) => state.unreadPSAs,
);

const selectModulePermissionsById = createSelector(
  [userState, (_, moduleId: string) => moduleId],
  (state, moduleId) =>
    state.loggedInUser?.modulePermissions?.find(
      (mp) => mp.moduleDefinitionId === moduleId,
    )?.permissions,
);

const selectTwoFactorConfig = createSelector(
  userState,
  (state) => state.twoFactor,
);

const selectTwoFactorEnabled = createSelector(userState, (state) =>
  Boolean(state.twoFactor?.enabled),
);

export const userSliceSelectors = {
  selectLoggedInUserId,
  selectLoggedInUser,
  selectIsUserOrgMember,
  selectLastUnreadPSAs,
  selectModulePermissionsById,
  selectTwoFactorConfig,
  selectTwoFactorEnabled,
};
